import React, { useEffect, useState } from "react";
import Header from "../components/layout/Header";
import Footer from "../components/layout/Footer";
import Banner from "../assets/images/Iqra.jpg";
import { Helmet } from "react-helmet";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { Link } from "react-router-dom";
import MiddleBanner from "../components/common/MiddleBanner";
import BgImage from "../assets/images/about-us/AboutUsMiddleBanner.webp";
import SlickSliderIqraProgram from "../components/common/SlickSliderIqraProgram";

const Iqra = () => {
  const [activeAccordion, setActiveAccordion] = useState(null);

  const toggleAccordion = (index) => {
    setActiveAccordion(activeAccordion === index ? null : index);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title> Iqra Program | Huntsville Islamic Center</title>
      </Helmet>
      <section id="website-responsive" className="px-0">
        <section
          className="container-fluid bg-common-banner"
          style={{ backgroundImage: `url(${Banner})` }}
        >
          <Header />
          <div className="fs-banner-title text-white fw-500 text-center py-5">
            <div className="py-md-5 mb-md-5">
              Iqra Program
              <div className="py-3 py-lg-4" />
            </div>
          </div>
        </section>
        <div className="py-4 py-md-5" />
        <section className="container-fluid text-md-center col-11 col-md-10 mx-auto">
          <div className="">
            {/* <div className="lh-sm">
              <div className="fs-ss-40 fw-600">
                Indeed this Qur'an guides to that which is most upright
              </div>
              <div className="fs-ss-22 fw-500 text-ss-secondary mt-2">
                (Surah Al-Israa:9)
              </div>
            </div> */}
            <div className="fs-ss-18 fw-400 mt-3">
              <div className="fs-ss-18 fw-500">
                "Indeed this Qur'an guides to that which is most upright and
                gives glad tidings to the believers who do righteous deeds that
                they will have a great reward"
                <br />
                (Surah Al-Israa:9)
              </div>
              <div className="mt-3 fs-ss-18 fw-500">
                The Messenger of Allah (peace be upon him) said: "Such a person
                who recites the Qur'an and masters it by heart, will be with the
                noble righteous scribes (in Heaven). And such a person who
                exerts himself to learn the Qur'an by heart, and recites it with
                great difficulty, will have a double reward."
              </div>
            </div>
          </div>
        </section>
        <div className="py-md-5" />
        <Tabs className="row justify-content-evenly align-items-center gx-0 gy-5 px-md-5 d-none d-md-flex">
          <TabList className="fs-ss-30 fw-600 text-dark col-11 col-lg-3">
            <div className="sticky-top">
              <Tab className="d-block py-3 cursor px-2 border-right">
                <div>About the Program</div>
              </Tab>

              <Tab className="d-block py-3 cursor px-2 border-right">
                <div>Objectives</div>
              </Tab>

              <Tab className="d-block py-3 cursor px-2 border-right">
                <div>Methodology</div>
              </Tab>
            </div>
          </TabList>

          <div className="col-11 col-lg-7">
            <TabPanel>
              <section className="container-fluid">
                <div className="">
                  <div className="fs-ss-18 fw-400 mt-3">
                    The IQRA Program is designed to enhance the Qur’an reading
                    skills using IQRA books series, it provides structured
                    Quranic reading education to children, youth, and adults. By
                    leveraging the IQRA book series, the program will ensure
                    systematic progress, leading students step by step from
                    learning the Arabic alphabet sounds all the way to reciting
                    the Qur’an correctly and independently inshaa Allah. The
                    program will also serve as a preparatory stage for students
                    intending to enroll in a Hifz (Qur’an memorization) and
                    Tafsir programs.
                  </div>
                </div>
              </section>
            </TabPanel>

            <TabPanel>
              <section className="container-fluid">
                <div className="">
                  <div className="fs-ss-18 fw-400 mt-3">
                    <ul>
                      <li>
                        Strengthen students’ connection with the Qur’an as their
                        primary source of guidance in life
                      </li>
                      <li>
                        Develop a generation of students who can recite the
                        Qur’an correctly and independently
                      </li>
                      <li>
                        Qualify students for the Hifz (Quran memorization) and
                        Tafsir programs
                      </li>
                    </ul>
                  </div>
                </div>
              </section>
            </TabPanel>

            <TabPanel>
              <section className="container-fluid">
                <div className="">
                  <div className="fs-ss-18 fw-400 mt-3">
                    <ul>
                      <li>
                        Utilize the IQRA book series (6 books) as the primary
                        curriculum, each book represents a level in the learning
                        journey.
                      </li>
                      <li>
                        Since the program is divided into six levels, there will
                        be an evaluation exam to ensure each student begins at
                        the correct level.
                      </li>
                      <li>
                        Students’ progress from one level to the next after
                        passing an exit exam.
                      </li>
                      <li>
                        After completing level six, the students will start
                        reading the whole Qur’an with their teachers to ensure
                        the correct recitation.
                      </li>
                      <li>
                        Separate classes will be organized for children, youth,
                        and adults to ensure appropriate learning environments.
                      </li>
                      <li>
                        Classrooms equipped with smart boards and / or
                        projectors are utilized to enhance the education
                        process.
                      </li>
                    </ul>
                  </div>
                </div>
              </section>
            </TabPanel>
          </div>
        </Tabs>
        <div className="py-4 py-md-0" />
        <section className="row justify-content-evenly gx-0 gy-5 px-md-5 d-md-none">
          <div className="col-11 col-lg-7">
            <section className="container-fluid">
              <div className="">
                <div className="fs-ss-40 fw-600">About the Program</div>
                <div className="fs-ss-18 fw-400 mt-3">
                  <div className="fs-ss-18 fw-400 mt-3">
                    The IQRA Program is designed to enhance the Qur’an reading
                    skills using IQRA books series, it provides structured
                    Quranic reading education to children, youth, and adults. By
                    leveraging the IQRA book series, the program will ensure
                    systematic progress, leading students step by step from
                    learning the Arabic alphabet sounds all the way to reciting
                    the Qur’an correctly and independently inshaa Allah. The
                    program will also serve as a preparatory stage for students
                    intending to enroll in a Hifz (Qur’an memorization) and
                    Tafsir programs.
                  </div>
                </div>
              </div>
            </section>

            <div className="py-4 py-md-5" />

            <section className="container-fluid">
              <div className="">
                <div className="fs-ss-40 fw-600">Objectives</div>
                <div className="fs-ss-18 fw-400 mt-3">
                  <ul>
                    <li>
                      Strengthen students’ connection with the Qur’an as their
                      primary source of guidance in life
                    </li>
                    <li>
                      Develop a generation of students who can recite the Qur’an
                      correctly and independently
                    </li>
                    <li>
                      Qualify students for the Hifz (Quran memorization) and
                      Tafsir programs
                    </li>
                  </ul>
                </div>
              </div>
            </section>

            <div className="py-4 py-md-5" />

            <section className="container-fluid">
              <div className="">
                <div className="fs-ss-40 fw-600">Methodology</div>
                <div className="fs-ss-18 fw-400 mt-3">
                  <ul>
                    <li>
                      Utilize the IQRA book series (6 books) as the primary
                      curriculum, each book represents a level in the learning
                      journey.
                    </li>
                    <li>
                      Since the program is divided into six levels, there will
                      be an evaluation exam to ensure each student begins at the
                      correct level.
                    </li>
                    <li>
                      Students’ progress from one level to the next after
                      passing an exit exam.
                    </li>
                    <li>
                      After completing level six, the students will start
                      reading the whole Qur’an with their teachers to ensure the
                      correct recitation.
                    </li>
                    <li>
                      Separate classes will be organized for children, youth,
                      and adults to ensure appropriate learning environments.
                    </li>
                    <li>
                      Classrooms equipped with smart boards and / or projectors
                      are utilized to enhance the education process.
                    </li>
                  </ul>
                </div>
              </div>
            </section>
          </div>
        </section>

        <div className="py-4 py-md-5" />

        <section className="container-fluid">
          <div className="row justify-content-cnter">
            <SlickSliderIqraProgram />
          </div>
        </section>
        <div className="py-4 py-md-5" />

        <section
          id="middle-banner"
          className="container-fluid text-white bg-middle-banner py-5"
          style={{ backgroundImage: `url(${BgImage})` }}
        >
          <div className="text-center py-md-5">
            <div className="fs-middle-banner fw-500 text-ss-secondary lh-sm text-hidayatullah">
              Begin with Iqra
            </div>
            <div className="fs-sub-middle-banner fw-500 mt-2 mb-4">
              A Lifelong Journey with the Qur’an
            </div>
            <a
              href="https://docs.google.com/forms/d/e/1FAIpQLSf-mGj2wo8pFBuZs-atimAvUMVXeEzsBSaJ0Tuxxy1nzmKE6Q/viewform"
              target="_blank"
              className="text-decoration-none rounded-5 border-0 btn-padding-middle pt-1 pb-2 hover-ss-donate fs-ss-20 text-dark fw-500"
            >
              Register Today
            </a>
          </div>
        </section>
        <div className="py-4 py-md-5" />

        <section className="container-fluid text-md-center col-11 col-lg-9 mx-auto">
          <div className="">
            <div className="lh-sm">
              <div className="fs-ss-40 fw-600 pb-3 pb-md-5">
                Frequently Asked Questions
              </div>
            </div>
            <div className="fs-ss-18 fw-400 mt-3 text-start">
              <div className="faq-accordion">
                <div className="faq-item mb-3">
                  <div
                    className="faq-header"
                    onClick={() => toggleAccordion(0)}
                  >
                    <div className="d-flex justify-content-between align-items-center">
                      <span className="fw-500 fs-ss-20">
                        {" "}
                        Who will teach in this program?
                      </span>
                      <span
                        className={`faq-icon ${activeAccordion === 0 ? "active" : ""}`}
                      >
                        {activeAccordion === 0 ? "−" : "+"}
                      </span>
                    </div>
                  </div>
                  <div
                    className={`faq-content ${activeAccordion === 0 ? "show" : ""}`}
                  >
                    <div className="text-black">
                      Only qualified teachers who successfully pass a screening
                      and qualifying exam related to the IQRA book series are
                      eligible to teach in this program.
                    </div>
                  </div>
                </div>

                <div className="faq-item mb-3">
                  <div
                    className="faq-header"
                    onClick={() => toggleAccordion(1)}
                  >
                    <div className="d-flex justify-content-between align-items-center">
                      <span className="fw-500 fs-ss-20">
                        {" "}
                        How do I register for the program?
                      </span>
                      <span
                        className={`faq-icon ${activeAccordion === 1 ? "active" : ""}`}
                      >
                        {activeAccordion === 1 ? "−" : "+"}
                      </span>
                    </div>
                  </div>
                  <div
                    className={`faq-content ${activeAccordion === 1 ? "show" : ""}`}
                  >
                    <div className="text-black">
                      To register, please complete the online form using the
                      link below. This will allow you to sign up and schedule
                      your evaluation exam:
                      <div className="mt-2">
                        <strong>
                          {" "}
                          <a
                            href="https://forms.gle/Fvs8K5FNULoQnACz9"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-ss-primary"
                          >
                            https://forms.gle/Fvs8K5FNULoQnACz9
                          </a>
                        </strong>
                      </div>
                      <div className="mt-1"></div>
                    </div>
                  </div>
                </div>

                <div className="faq-item mb-3">
                  <div
                    className="faq-header"
                    onClick={() => toggleAccordion(2)}
                  >
                    <div className="d-flex justify-content-between align-items-center">
                      <span className="fw-500 fs-ss-20">
                        {" "}
                        What class schedule options are available?
                      </span>
                      <span
                        className={`faq-icon ${activeAccordion === 2 ? "active" : ""}`}
                      >
                        {activeAccordion === 2 ? "−" : "+"}
                      </span>
                    </div>
                  </div>
                  <div
                    className={`faq-content ${activeAccordion === 2 ? "show" : ""}`}
                  >
                    <div className="text-black">
                      Students must choose one of the following schedules based
                      on their enrollment type:
                      <div className="mt-4">
                        <div className="fw-500">For Children / Youth</div>
                        <ul className="mt-1">
                          <li>Sunday: 11:45 AM – 1:00 PM</li>
                          <li>Thursday: 6:00 PM – 7:00 PM</li>
                        </ul>
                      </div>
                      <div className="mt-3">
                        <div className="fw-500">For Adults</div>
                        <ul className="mt-1">
                          <li>Sunday: 11:00 AM – 12:00 PM</li>
                          <li>Thursday: 6:00 PM – 7:00 PM</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="faq-item mb-3">
                  <div
                    className="faq-header"
                    onClick={() => toggleAccordion(3)}
                  >
                    <div className="d-flex justify-content-between align-items-center">
                      <span className="fw-500 fs-ss-20">
                        {" "}
                        What is the program fee?
                      </span>
                      <span
                        className={`faq-icon ${activeAccordion === 3 ? "active" : ""}`}
                      >
                        {activeAccordion === 3 ? "−" : "+"}
                      </span>
                    </div>
                  </div>
                  <div
                    className={`faq-content ${activeAccordion === 3 ? "show" : ""}`}
                  >
                    <div className="text-black">
                      <ul className="mt-1 mb-0">
                        <li>One-time registration fee: $50</li>
                        <li>Monthly tuition for Sunday School students: $40</li>
                        <li>
                          Monthly tuition for Non-Sunday School students: $60
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="faq-item mb-3">
                  <div
                    className="faq-header"
                    onClick={() => toggleAccordion(4)}
                  >
                    <div className="d-flex justify-content-between align-items-center">
                      <span className="fw-500 fs-ss-20">
                        {" "}
                        What is the only way to achieve the program's
                        objectives?
                      </span>
                      <span
                        className={`faq-icon ${activeAccordion === 4 ? "active" : ""}`}
                      >
                        {activeAccordion === 4 ? "−" : "+"}
                      </span>
                    </div>
                  </div>
                  <div
                    className={`faq-content ${activeAccordion === 4 ? "show" : ""}`}
                  >
                    <div className="text-black">
                      The only way to achieve the program’s objectives is
                      through regular and consistent class attendance.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div className="py-4 py-md-5" />
        <style jsx>{`
          .faq-accordion {
            border: none;
          }

          .faq-item {
            border: 1px solid #e9ecef;
            border-radius: 12px;
            overflow: hidden;
            transition: all 0.3s ease;
            background: #ffffff;
          }

          .faq-item:hover {
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
            border-color: #dee2e6;
          }

          .faq-header {
            background: #f8f9fa;
            padding: 20px 24px;
            cursor: pointer;
            margin: 0;
            font-size: 16px;
            border: none;
            width: 100%;
            text-align: left;
            transition: all 0.3s ease;
            border-radius: 12px 12px 0 0;
          }

          .faq-header:hover {
            background: #e9ecef;
          }

          .faq-icon {
            font-size: 24px;
            font-weight: 300;
            color: #ffffff;
            transition: all 0.3s ease;
            width: 28px;
            height: 28px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
            background: #045a4f;
            border: 1px solid #045a4f;
          }

          .faq-icon.active {
            color: #ffffff;
            background: #045a4f;
            border-color: #045a4f;
          }

          @media (max-width: 767px) {
            .faq-icon {
              display: none;
            }
          }

          .faq-content {
            max-height: 0;
            overflow: hidden;
            transition:
              max-height 0.4s ease,
              padding 0.4s ease;
            background: #ffffff;
            padding: 0 24px;
          }

          .faq-content.show {
            max-height: 600px;
            padding: 20px 24px;
          }

          .faq-content ul {
            margin: 8px 0 0 20px;
            padding: 0;
          }

          .faq-content li {
            margin-bottom: 8px;
            line-height: 1.6;
          }
        `}</style>
        <Footer />
      </section>
    </>
  );
};

export default Iqra;
